module.exports = __webpack_public_path__ + "media/images/app-store-btn-7d26ee11f5280abb19ed5c492ad6d263.svg";